// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-file-list .strong{font-weight:500}.drop-file-list .b-icon:hover{cursor:pointer;color:#ea2d2d}", ""]);
// Exports
module.exports = exports;
